/*
 * Copyright (C) 2021 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    inject
} from '@angular/core';
import {TSFinanzielleSituationResultateDTO} from '../../../../../models/dto/TSFinanzielleSituationResultateDTO';
import {LogFactory} from '../../../../../utils/log-factory/LogFactory';
import {GesuchModelManager} from '../../../../service/gesuchModelManager';
import {FinanzielleSituationLuzernService} from '../finanzielle-situation-luzern.service';

const LOG = LogFactory.createLog('ResultatComponent');

@Component({
    selector: 'dv-resultat',
    templateUrl: './resultat.component.html',
    styleUrls: ['./resultat.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResultatComponent implements OnInit {
    protected ref = inject(ChangeDetectorRef);
    private readonly finSitLuService = inject(
        FinanzielleSituationLuzernService
    );
    private readonly gesuchModelManager = inject(GesuchModelManager);

    @Input()
    public isGemeinsam: boolean;

    @Input()
    public year: number | string;

    @Input()
    public antragstellerNummer: number;

    public resultate?: TSFinanzielleSituationResultateDTO;

    public ngOnInit(): void {
        this.setupCalculation();
    }

    public setupCalculation(): void {
        this.finSitLuService.massgebendesEinkommenStore.subscribe(
            resultate => {
                this.resultate = resultate;
                this.ref.markForCheck();
            },
            error => LOG.error(error)
        );
    }

    public getAntragsteller1Name(): string {
        return this.gesuchModelManager
            .getGesuch()
            .gesuchsteller1.extractFullName();
    }

    public getAntragsteller2Name(): string {
        return this.gesuchModelManager
            .getGesuch()
            .gesuchsteller2.extractFullName();
    }
}
